import { render, staticRenderFns } from "./TempoProcesExpurgoMensal.vue?vue&type=template&id=02c92140&"
import script from "./TempoProcesExpurgoMensal.vue?vue&type=script&lang=js&"
export * from "./TempoProcesExpurgoMensal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports